module.exports = __webpack_public_path__ + "static/media/price_section.d5eac558.png";